import { render, staticRenderFns } from "./ArticleFormModal.vue?vue&type=template&id=7d4a6b02&scoped=true"
import script from "./ArticleFormModal.vue?vue&type=script&lang=js"
export * from "./ArticleFormModal.vue?vue&type=script&lang=js"
import style0 from "./ArticleFormModal.vue?vue&type=style&index=0&id=7d4a6b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a6b02",
  null
  
)

export default component.exports